import IconArrowDownUp from '@/assets/icons/lucide/arrow-down-up.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useTranslation } from 'react-i18next';

interface Props {
  field: FIELD__token;
}

export function G_BUTTON__token_change_sign({ field }: Props) {
  /*
   * STORE
   */

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const component_id = `${ENUM__component_type.PAGE_GENERATION_TOKEN_BAR}_${field.meta.field_id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_GENERATION);

  const tooltip_title = t(
    field.is_positive.get_value()
      ? i18n_page_generation.sidebar_user_input.button.token_change_sign.tooltip.title_negative
      : i18n_page_generation.sidebar_user_input.button.token_change_sign.tooltip.title_positive,
  );

  let arrow_opacity_down = !field.is_positive.get_value() ? 0.4 : 1;
  let arrow_opacity_up = field.is_positive.get_value() ? 0.4 : 1;

  /*
   * EVENTS
   */
  async function onClick() {
    let field_new = field.clone();
    field_new.is_positive.invert();

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);

    await notifier.send_action();
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__tooltip delay_duration={0} skip_delay_duration={0} {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        {...{ onClick }}
        disabled={is_disabled()}
        size="rect-10-8"
        style={{ '--arrow-opacity-down': arrow_opacity_down, '--arrow-opacity-up': arrow_opacity_up }}
        iconClassNameBase="text-component-item-foreground size-3"
        iconClassNameHovered="!text-bar-foreground"
        Icon={IconArrowDownUp}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
